import { APP_GLOBAL_KEY } from 'modules/app/constants/index.js'

export function isBotUserAgentUtil (userAgent) {
  if (SERVER) {
    const isbotObj = require('isbot')
    return isbotObj.isbot(userAgent)
  }
  return !!(BROWSER && window[APP_GLOBAL_KEY.IS_BOT])
}
